import service from '@/utils/request'; // GetBairunStationDiscountPriceOpLogList 分页获取油站优惠操作记录
// @Tags Station
// @Summary 分页获取油站优惠操作记录
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceOpLogSearch true "分页获取油站优惠操作记录"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationOpLog/getDiscountPriceOpLogList [get]

export var getBairunStationDiscountPriceOpLogList = function getBairunStationDiscountPriceOpLogList(params) {
  return service({
    url: '/stationOpLog/getDiscountPriceOpLogList',
    method: 'get',
    params: params
  });
};